import { linkBuilders } from '@/helpers/mixins'

export default {
    mixins: [linkBuilders],
    computed: {
        fitmentData() {
            return this.$store.state.fitment.data
        },
        isSameDayShippingMode() {
            return this.$store.state.fitment.modal.isSameDayShippingMode
        },
        isMMYMode() {
            return this.$store.state.fitment.modal.isMMYMode
        },
        hasFullFitment() {
            return this.$store.getters['fitment/hasFullFitment']
        },
        requiredSelectTypes() {
            return this.$store.getters['fitment/requiredSelectTypes']
        },
        optionalSelectTypes() {
            return this.$store.getters['fitment/optionalSelectTypes']
        },
        allDoneSelecting() {
            const requiredSelectValidation = this.requiredSelectTypes.filter((select) => {
                return select.currentValue === -1
            })

            const optionalSelectValidation = this.optionalSelectTypes.filter((select) => {
                return select.hasError
            })

            return requiredSelectValidation.length === 0 && optionalSelectValidation.length === 0
        },
    },
    methods: {
        selectChanged(obj) {
            this.$store.dispatch('fitment/setSelectValue', obj).then(() => {
                this.$uiEvents.$emit('fitmentChanged', obj)
                this.$store.dispatch('fitment/fillNextSelect', obj)
            })
        },
        selectChangedOptional(obj) {
            this.$store.dispatch('fitment/setSelectValue', obj).then(() => {
                this.$uiEvents.$emit('fitmentChanged', obj)
                this.$store.dispatch('fitment/validateFitment', obj)
            })
        },
        /**
         * @param {Boolean} ignoreISSD is used by fitmentInline to skip adding sameDayShipping to query
         */
        saveFitment(ignoreISSD) {
            this.$store.dispatch('fitment/saveFitment')
            let route = {}
            // We want to redirect to the MMY page from 404 pages
            const is404Page = this.$store.state.is404

            // Send to the MMY page if you are:
            // on the homepage
            // update the mmy page
            // set the mode to sendToMMY
            if (['home', 'mmy'].includes(this.$route.name) || is404Page || this.isMMYMode) {
                // linkBuilder isn't made for non fitment urls (v/blah/blah) as it doesn't really seem to make sense
                route = { name: 'mmy', params: this.fitmentData, query: {} }
            } else {
                const params = Object.assign({}, this.$route.params)
                params.forceReload = true

                const query = {}
                // If we have a "q" in the query obj it means we are on the search page. We need to pass that along when we update fitment.
                if (this.$route.query.q) query.q = this.$route.query.q

                // If we have a "sort" in the query obj it means we have a sort active. We need to pass that along when we update fitment.
                if (this.$route.query.sort) query.sort = this.$route.query.sort

                // If we have a "token" in the query obj it means we have an build edit. We need to pass that along when we update fitment.
                if (this.$route.query.token) query.token = this.$route.query.token

                route = this.linkBuilder({ name: this.$route.name, params, query })
            }

            // If we are in the sameDayShipping mode then we need to add this query string so the facet will display on the cat page.
            if (this.isSameDayShippingMode && !ignoreISSD) route.query.sameDayShipping = true

            // did you only update a BBE?  Add a dumb query param to force the route change since we only keep mmy in the url
            if (this.$route.fullPath === this.$router.resolve(route).href)
                route.query.z = new Date().getTime()

            if (this.$route.name === 'sku') this.$push.replace(route)
            else this.$push.to(route)
        },
    },
}
